export default __webpack_public_path__ + "assets/images/f9bdfdb4784be601a1187ae0444cf6ae.svg";